<script lang="ts">
	//Svelte hooks
	import { beforeUpdate } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	//Types
	import type { DeviceButtonPropsTypes } from '@Shelly/shelly-design-system';
	//Helpers
	import { getBoostState, requestBoostTrvDevice } from '../../../helpers/trv_helpers';
	import { unlockPin } from '../../../helpers/pin_lock_helpers';
	//Stores
	import { pin_unlocked_devices } from 'src/stores/device-runtime/pin-unlocked';
	import { devices } from 'src/stores/lists/devices';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Design system components
	import { DeviceButton, Text, ControlsContainer } from '@Shelly/shelly-design-system';
	import PinUnlock from '../../../components/PinUnlock.svelte';

	export let device;
	export let settings;
	export let status;
	export let size: DeviceButtonPropsTypes['size'] = 'l';
	export let title = $format('sub_settings_title_boost', { default: 'Boost' });

	let isRequestLoading = false;
	let isWaitingStatusChange = false;
	let startBoosting = false;
	let stopBoosting = false;
	let boostState: {
		type?: string;
		icon?: string;
		time?: string | number;
		active?: boolean;
		boosted?: boolean;
		boost_enabled?: boolean;
	} = {};
	let pinLocked;
	let showModal = false;
	let manual = false;

	beforeUpdate(() => {
		pinLocked =
			typeof $pin_unlocked_devices[device.id] === 'undefined' && $devices[device.id]?.pin_lock;
		manual = !settings?.thermostats?.[0]?.target_t?.enabled;
		boostState = getBoostState(device, settings, status);
		checkIsStatusChange();
	});

	const checkIsStatusChange = () => {
		if (isWaitingStatusChange && boostState.active && startBoosting) {
			isWaitingStatusChange = false;
			startBoosting = false;
		} else if (isWaitingStatusChange && !boostState.active && stopBoosting) {
			isWaitingStatusChange = false;
			stopBoosting = false;
		}
	};

	const onToggleBtn = () => {
		isWaitingStatusChange = true;

		if (boostState.active) {
			stopBoosting = true;
		} else {
			startBoosting = true;
		}
	};

	const handleClick = async () => {
		if (!pinLocked) {
			isRequestLoading = true;
			onToggleBtn();
			await requestBoostTrvDevice(device, boostState.boosted);
			isRequestLoading = false;
		} else {
			showModal = true;
		}
	};

	const handlePin = () => {
		pinLocked = unlockPin(device, pinLocked);
		handleClick();
	};
</script>

{#if Object.keys(boostState).length > 0 && !manual}
	<!-- Hide boost button if getBoostState is empty object or if TRV is in manual mode -->
	<ControlsContainer color={$showNewLayout ? 'color-0' : undefined}>
		<svelte:fragment slot="first">
			<DeviceButton
				id="devicebutton-g7rcqh1"
				aria-label={$format('button_boost', { default: 'Boost' })}
				variant="primary"
				{size}
				disabled={isWaitingStatusChange || isRequestLoading}
				isLoading={isWaitingStatusChange || isRequestLoading}
				isActive={boostState.active}
				icon={boostState.icon}
				on:click={handleClick}
			/>

			{#if title}
				<Text class="text-bold mt-s">{title}</Text>
			{/if}
		</svelte:fragment>
	</ControlsContainer>
{/if}
{#if showModal}
	<PinUnlock bind:showModal on:unlock={handlePin} on:cancel={() => (showModal = false)} />
{/if}
